import API_TYPE_ID from "../../../src-client-lib/api/type-ids.js";
import TemplateParser from "../utils/templateParser";
import {variableTypes} from "../../components/dashboard/control-widget/selection-contorl/constants";
import InternalEventBus from "../utils/internalEventBus";
import InternalEvent from "../constants/internalEvent";
import {Subject} from "rxjs";

const localStorageKeyForLastOpenedDashboardId = "lastOpenedDashboard";
const defaultDashboard = {
  title: "NEW DASHBOARD",
  tabPosition: 0,
  variables: "{}"
};


class DashboardService {
  constructor() {
    this.activeDashboard = undefined;
    this.dashboards = undefined;
    this.dashboardStates = {};
    this.dashboardStream = new Subject();
  }

  /***
   * Search for the dashboard state by dashboard id.
   * @param dashboardId
   * @returns {Promise}
   */
  findDashboardStateByDashboardId(dashboardId) {
    if (this.dashboardStates[dashboardId]) {
      return new Promise((resolve) => {
        resolve(this.dashboardStates[dashboardId]);
      });
    } else {
      return new Promise((resolve, reject) => {
        smashClient.getDashboardState(dashboardId, (response) => {
          if (response.data.length === 0) {
            console.log(`Cannot find dashboard state for dashboard ${dashboardId}`);
            console.log(`Deleting dashboard ${dashboardId}`);
            smashClient.deleteInvalidDashboard(dashboardId);
          } else if (response.data.length === 1) {
            let state = response.data[0];
            state.dashboardState = JSON.parse(state.dashboardState);
            this.dashboardStates[dashboardId] = state;
            resolve(state);
          }
        });
      });
    }
  }

  updateSharedDashboard(dashboard) {
    return new Promise((resolve, reject) => {
      smashClient.getDashboardById(dashboard.originalDashboard, (response) => {
        if (response.data.length === 0) {
          throw `Cannot find the target dashboard ${dashboardId}`;
        } else if (response.data.length === 1) {
          const originalDashboardUpdatedTime = response.data[0].originalDashboardUpdateTime;
          if (originalDashboardUpdatedTime && originalDashboardUpdatedTime !== dashboard.originalDashboardUpdateTime) {
            // replace dashboard and dashboardState
            // dashboard.
          }
          resolve(state);
        }
      });
    });
  }

  createDashboard(newDashboard) {
    return new Promise((resolve, reject) => {
      smashClient.addDashboard(newDashboard, (response) => {
        if (response.typeId === API_TYPE_ID.UIDashboardCreated) {
          resolve(response);
          response.currentPersistedData.variables = {};
          this.dashboards.push(response.currentPersistedData);
        } else {
          reject();
        }
      });
    });
  }

  /**
   * Copies the current dashboard.
   * @returns {Promise}
   */
  copyCurrentDashboard() {
    const copyDashboard = {
      tabPosition: this.dashboards.length,
      title: this.activeDashboard.title + ' copy',
      originalDashboard: null,
      variables: JSON.stringify(this.activeDashboard.variables)
    };
    return new Promise((resolve, reject) => {
      smashClient.addDashboard(copyDashboard, (response) => {
        if (response.typeId === API_TYPE_ID.UIDashboardCreated) {
          // parse variable and add the copied dashboard to the cache
          response.currentPersistedData.variables = JSON.parse(response.currentPersistedData.variables);
          this.dashboards.push(response.currentPersistedData);

          this.findDashboardStateByDashboardId(this.activeDashboard.persistenceId)
            .then(state => {
              const copyState = JSON.parse(JSON.stringify(state));
              copyState.dashboard = response.currentPersistedData.persistenceId;
              copyState.persistenceId = response.currentPersistedData.dashboardStateId;
              this.dashboardStates[response.currentPersistedData.persistenceId] = copyState;
              return this.updateDashboardState(response.currentPersistedData.persistenceId,
                response.currentPersistedData.dashboardStateId, copyState.dashboardState)

            })
            .then(() => {
              resolve(response.currentPersistedData.persistenceId);
            });
        } else {
          reject();
        }
      });
    });
  }


  deleteDashboard(dashboardId) {
    return new Promise((resolve, reject) => {
      this.findDashboardStateByDashboardId(dashboardId)
        .then(state => {

          const stateId = state ? state.persistenceId : null;
          const dashboardToDelete = this.dashboards.find(d => d.persistenceId === dashboardId);
          const dashboardsToUpdatePositions = this.dashboards.filter(d => d.tabPosition > dashboardToDelete.tabPosition);
          dashboardsToUpdatePositions.forEach(d => {
            d.position--;
            this.updateDashboard(d, d);
          });

          this.dashboards = this.dashboards.filter(d => d.persistenceId !== dashboardId);

          // find the next dashboard to render
          if (this.dashboards.length > 0 && this.activeDashboard.persistenceId === dashboardId) {
            let nextDashboard = this.dashboards.find(d => d.tabPosition === dashboardToDelete.tabPosition + 1);
            if (!nextDashboard) {
              nextDashboard = this.dashboards[0];
            }
            nextDashboard.activated = true;
            this.activeDashboard = nextDashboard;
          }

          smashClient.deleteDashboard(dashboardId, stateId, (response) => {
            if (response.typeId === API_TYPE_ID.UIDashboardRemoved) {
              if (this.dashboards.length === 0) {
                this.createDashboard(defaultDashboard)
                  .then(res => {
                    this.dashboards = [res.currentPersistedData];
                    this.findAndSetActiveDashboard(this.dashboards);
                    resolve();
                  });
              } else {
                resolve();
              }
            } else {
              reject();
            }
          });
        });
    });
  }

  deleteSharedDashboard(dashboardId) {
    return new Promise((resolve, reject) => {
      this.findDashboardStateByDashboardId(dashboardId)
        .then(state => {
          const stateId = state ? state.persistenceId : null;
          smashClient.deleteDashboard(dashboardId, stateId, (response) => {
            if (response.typeId === API_TYPE_ID.UIDashboardRemoved) {
              this.dashboards = this.dashboards.filter(d => d.persistenceId !== dashboardId);

              // find the next dashboard to render
              if (this.activeDashboard.persistenceId === dashboardId) {
                const nextDashboard = this.dashboards[0];
                nextDashboard.activated = true;
                this.activeDashboard = nextDashboard;
              }

              resolve();
            } else {
              reject();
            }
          });
        });
    });
  }

  /***
   * Updates a dashboard.
   * @param prevDashboard
   * @param newDashboard
   * @returns {Promise}
   */
  updateDashboard(prevDashboard, newDashboard) {
    if (newDashboard.originalDashboard == null) {
      newDashboard.originalDashboardUpdateTime = new Date().toISOString().replace('Z', '');
    }
    return new Promise((resolve, reject) => {
      smashClient.updateDashboard(prevDashboard, newDashboard, (response) => {
        if (response.typeId === API_TYPE_ID.UIDashboardUpdated) {
          if (this.activeDashboard && this.activeDashboard.persistenceId === newDashboard.persistenceId) {
            this.activeDashboard = newDashboard;
          }
          const index = this.dashboards.findIndex(d => d.persistenceId === newDashboard.persistenceId);
          if (index > -1) {
            this.dashboards[index] = newDashboard;
          }
          this.dashboardStream.next(newDashboard);
          resolve();
        } else {
          reject();
        }
      });
    });
  }

  /***
   * Updates dashboard state.
   * @param dashboardId
   * @param dashboardStateId
   * @param dashboardState
   * @returns {Promise}
   */
  updateDashboardState(dashboardId, dashboardStateId, dashboardState) {
    return new Promise((resolve, reject) => {

      const copyDashboardState = JSON.parse(JSON.stringify(dashboardState));
      this._removeTempWidgetData(copyDashboardState);

      let previousDashboardState = {
        dashboard: dashboardId,
        persistenceId: dashboardStateId,
        dashboardState: JSON.stringify({})
      };

      let newState = {
        dashboard: dashboardId,
        persistenceId: dashboardStateId,
        dashboardState: JSON.stringify(copyDashboardState)
      };

      smashClient.saveDashboardState(previousDashboardState, newState, (response) => {
        if (response.typeId === API_TYPE_ID.UIDashboardStateUpdated) {
          console.log("dashboard state updated!");
          this.dashboardStates[dashboardId].dashboardState = copyDashboardState;
          resolve();
        } else {
          console.log("dashboard state update rejected!");
          reject();
        }
      });

      smashClient.getDashboardById(dashboardId, response => {
        if (response.data.length === 1) {
          const dashboard = response.data[0];
          dashboard.variables = dashboard.variables ? JSON.parse(dashboard.variables) : {};
          const currentDashboard = JSON.parse(JSON.stringify(dashboard));
          currentDashboard.activated = true;
          this.updateDashboard(dashboard, currentDashboard);
        }
      });
    });
  }

  _removeTempWidgetData(dashboardState) {
    dashboardState.forEach(state => {
      state.widgetModel.legends.forEach(legend => {
        delete legend.functions;
        delete legend.serverSideFunction;
        delete legend.serverSideFunctionExpression;
        delete legend.registeredDatasets;
        delete legend.componentHistoricDataLoadTracker;
        delete legend.areHistoricDataLoaded;
      })
    });

  }

  getCurrentDashboard() {
    return this.findDashboardById(this.activeDashboard.persistenceId);
  }

  getCurrentDashboardId() {
    return localStorage.getItem(localStorageKeyForLastOpenedDashboardId);
  }

  addOrUpdateWidgetToAllDashboard(widget, id) {
    return this.findDashboardById(id, true)
      .then(dashboard => {
        let updated = false;
        for (let i = 0; i < dashboard.state.dashboardState.length; i++) {
          let widgetModel = dashboard.state.dashboardState[i].widgetModel;
          if (widgetModel.id === widget.id) {
            widgetModel.legends = widget.legends;
            widgetModel.title = widget.title;
            widgetModel.autoAdjustWindowSize = widget.autoAdjustWindowSize;
            widgetModel.centerZeroLine = widget.centerZeroLine;
            widgetModel.splitLeftRight = widget.splitLeftRight;
            updated = true;
            break;
          }
        }

        if (!updated) {
          dashboard.state.dashboardState.push({
            gridsterModel: null,
            widgetModel: widget
          });
        }

        return this.updateDashboardState(
          dashboard.persistenceId,
          dashboard.state.persistenceId,
          dashboard.state.dashboardState);
      });
  }


  addOrUpdateWidgetToCurrentDashboard(widget) {
    let currentDashboardId = localStorage.getItem(localStorageKeyForLastOpenedDashboardId);
    return this.addOrUpdateWidgetToDashboard(currentDashboardId, widget);
  }

  addOrUpdateWidgetToDashboard(dashboardId, widget) {
    return this.findDashboardById(dashboardId, true)
      .then(dashboard => {
        let updated = false;
        for (let i = 0; i < dashboard.state.dashboardState.length; i++) {
          let widgetModel = dashboard.state.dashboardState[i].widgetModel;
          if (widgetModel.id === widget.id) {
            widgetModel.legends = widget.legends;
            widgetModel.title = widget.title;
            widgetModel.autoAdjustWindowSize = widget.autoAdjustWindowSize || false;
            widgetModel.centerZeroLine = widget.centerZeroLine || false;
            widgetModel.splitLeftRight = widget.splitLeftRight || false;
            widgetModel.metaData = widget.metaData;
            updated = true;
            break;
          }
        }

        if (!updated) {
          dashboard.state.dashboardState.push({
            gridsterModel: null,
            widgetModel: widget
          });
        }

        return this.updateDashboardState(
          dashboard.persistenceId,
          dashboard.state.persistenceId,
          dashboard.state.dashboardState);
      });
  }

  /***
   * Finds all dashboards and sets an active dashboard.
   * @returns {Promise}
   */
  getAllDashboards() {
    return new Promise((resolve, reject) => {
      smashClient.getDashboards((response) => {
        if (response.data.length === 0) {
          this.createDashboard(defaultDashboard)
            .then(res => {
              this.dashboards = [res.currentPersistedData];
              this.findAndSetActiveDashboard(this.dashboards);
              resolve(this.dashboards);
            });
        } else {
          let dashboards = response.data;
          dashboards.forEach(d => {
            d.variables = d.variables ? JSON.parse(d.variables) : {}
          });
          this.dashboards = dashboards;
          this.findAndSetActiveDashboard(this.dashboards);
          resolve(this.dashboards);
        }

      });
      // if (this.dashboards === undefined || forceLoad) {
      //   smashClient.getDashboards((response) => {
      //     if (response.data.length === 0) {
      //       this.createDashboard(defaultDashboard)
      //         .then(res => {
      //           this.dashboards = [res.currentPersistedData];
      //           this.findAndSetActiveDashboard(this.dashboards);
      //           resolve(this.dashboards);
      //         });
      //     } else {
      //       let dashboards = response.data;
      //       dashboards.forEach(d => {
      //         d.variables = d.variables ? JSON.parse(d.variables) : {}
      //       });
      //       this.dashboards = dashboards;
      //       this.findAndSetActiveDashboard(this.dashboards);
      //       resolve(this.dashboards);
      //     }
      //
      //   });
      // } else {
      //   resolve(this.dashboards);
      // }
    });
  }

  findDashboardById(dashboardId, withState = true) {
    return this.getAllDashboards()
      .then(dashboards => {
        const dashboard = dashboards.find(d => d.persistenceId === dashboardId);
        if (dashboard) {
          if (withState) {
            return this.findDashboardStateByDashboardId(dashboardId)
              .then(state => {
                dashboard.state = state;
                return dashboard;
              });
          } else {
            return dashboard;
          }
        } else {
          return null;
        }
      })
  }

  /***
   * Retrieves the last opened dashboardId from the local storage and sets an active dashboard.
   * @param dashboards
   */
  findAndSetActiveDashboard(dashboards) {
    const lastOpenedDashboardId = localStorage.getItem(localStorageKeyForLastOpenedDashboardId);
    if (lastOpenedDashboardId != null) {
      const lastOpenedDashboardIndex = dashboards.findIndex(d => d.persistenceId === lastOpenedDashboardId);
      if (lastOpenedDashboardIndex > -1) {
        dashboards[lastOpenedDashboardIndex].activated = true;
        this.activeDashboard = dashboards[lastOpenedDashboardIndex];
      } else {
        dashboards[0].activated = true;
        this.activeDashboard = dashboards[0];
      }
    } else if (dashboards.length > 0) {
      dashboards[0].activated = true;
      this.activeDashboard = dashboards[0];
    }
  }

  getCurrentDashboardVariables() {
    if (this.activeDashboard != null) {
      return this.activeDashboard.variables || {};
    } else {
      return {};
    }
  }

  getCurrentDashboardVariableById(id) {
    const dashboardVariables = this.getCurrentDashboardVariables();
    for (let prop in dashboardVariables) {
      if (dashboardVariables[prop].id === id) {
        return dashboardVariables[prop];
      }
    }
    return null;
  }

  updateDashboardVariables(variablesToUpdate, variableIdsToRemove = []) {
    const dashboardCopy = JSON.parse(JSON.stringify(this.activeDashboard));

    if (Array.isArray(variablesToUpdate)) {
      variablesToUpdate.forEach(v => {
        dashboardCopy.variables[v.id] = v;
      });
    } else if (typeof variablesToUpdate === "object") {
      for (let prop in variablesToUpdate) {
        dashboardCopy.variables[prop] = variablesToUpdate[prop];
      }
    }

    variableIdsToRemove.forEach(id => {
      delete dashboardCopy.variables[id];
    });

    this.evaluateDashboardVariables(dashboardCopy.variables);
    InternalEventBus.publish(InternalEvent.Dashboard.DASHBOARD_VARIABLE_UPDATED);
    return this.updateDashboard(this.activeDashboard, dashboardCopy)
  }

  evaluateDashboardVariables(variables) {
    for (let prop in variables) {
      if (variables[prop].type === variableTypes.EXPRESSION) {
        const parsed = TemplateParser.parseTemplate(variables[prop].expression, true, variables);
        try {
          variables[prop].value = eval(parsed);
        } catch (e) {
          console.error('[DashboardService] Cannot evaluate expression: ' + parsed);
        }
      }
    }
  }

  setActiveDashboard(dashboard) {
    this.activeDashboard = dashboard;
  }

  changeActiveDashboard(dashboardId) {
    this.dashboards.forEach(d => {
      d.activated = d.persistenceId === dashboardId;
      if (d.activated) {
        this.activeDashboard = d;
      }
    });
  }

  getActiveDashboardLockState() {
    let locked = true;
    if (this.activeDashboard && this.activeDashboard.variables) {
      if (this.activeDashboard.variables.lockDashboard) {
        locked = this.activeDashboard.variables.lockDashboard.value;
      }

      // cannot modify shared dashboard
      if (this.activeDashboard.originalDashboard) {
        locked = true;
      }
    }
    return locked;
  }

  shareDashboard(targetUserPersistenceIds) {
    this.getCurrentDashboard()
      .then(currentDashboard => {
        const dateTime = new Date().toISOString().replace("Z", "");
        if (!currentDashboard.originalDashboardUpdateTime) {
          currentDashboard.originalDashboardUpdateTime = dateTime;
        }
        targetUserPersistenceIds.forEach(persistenceId => {
          smashClient.getDashboardsById(persistenceId, res => {
            const sharedDashboard = res.data.find(d => d.originalDashboard && d.originalDashboard === currentDashboard.persistenceId);
            if (sharedDashboard) {
              this.overwriteSharedDashboard(currentDashboard, sharedDashboard);
            } else {
              const copy = JSON.parse(JSON.stringify(currentDashboard.state.dashboardState))
              this._removeTempWidgetData(copy);
              smashClient.shareDashboard(persistenceId, currentDashboard, JSON.stringify(copy), () => {
              });
            }
          });
        });
      });
  }

  /**
   * Overwrites shared dashboard.
   * @param currentDashboard
   * @param sharedDashboardt
   */
  overwriteSharedDashboard(currentDashboard, sharedDashboard) {
    // console.log(currentDashboard);
    // console.log(sharedDashboard);
    sharedDashboard.originalDashboardUpdateTime = currentDashboard.originalDashboardUpdateTime;
    sharedDashboard.variables = currentDashboard.variables;
    smashClient.getDashboardState(sharedDashboard.persistenceId, (response) => {
      if (response.data.length === 0) {
        throw `Cannot find dashboard state for dashboard ${dashboardId}`;
      } else if (response.data.length === 1) {
        const state = response.data[0];
        const newState = JSON.parse(JSON.stringify(state));
        // remove functions
        newState.dashboardState = JSON.parse(JSON.stringify(currentDashboard.state.dashboardState));
        smashClient.saveDashboardState(state, newState, () => {
        });
      }
    });
    smashClient.updateDashboard(sharedDashboard, sharedDashboard);
  }

  /**
   * Checks the original dashboard for update.
   * @param sharedDashboard
   * @returns {Promise}
   */
  checkSharedDashboardForUpdate(sharedDashboard) {
    return new Promise((resolve, reject) => {
      smashClient.getDashboardById(sharedDashboard.originalDashboard, response => {
        if (response.data.length === 0) {
          // original dashboard was deleted. Thus, no update is needed.
          resolve();
        } else if (response.data.length === 1) {
          const originalDashboard = response.data[0];
          if (originalDashboard.originalDashboardUpdateTime !== sharedDashboard.originalDashboardUpdateTime) {
            this.activeDashboard.originalDashboardUpdateTime = originalDashboard.originalDashboardUpdateTime;
            const promises = [
              this.updateDashboardVariablesFromOriginalDashboard(originalDashboard, sharedDashboard),
              this.updateDashboardStateFromOriginalDashboard(originalDashboard.persistenceId, sharedDashboard.persistenceId)
            ];
            Promise.all(promises)
              .then(([variables, state]) => resolve(state));
          } else {
            resolve();
          }
        }
      });
    });

  }

  /***
   * Overwrites the variables of shared dashboard with the variables of the original dashboard.
   * @param originalDashboard
   * @param sharedDashboard
   */
  updateDashboardVariablesFromOriginalDashboard(originalDashboard, sharedDashboard) {
    const gridBaseDimensions = sharedDashboard.variables.gridBaseDimensions;
    // copy variables from original dashboard
    const variables = JSON.parse(originalDashboard.variables);

    // keep user's dashboard variable values
    for (let variableId in sharedDashboard.variables) {
      const variable = variables[variableId];
      const sharedVariable = sharedDashboard.variables[variableId]

      if (variable && variable.type === sharedVariable.type) {
        variables[variableId] = sharedDashboard.variables[variableId];
      }
    }

    if (gridBaseDimensions) {
      variables.gridBaseDimensions = gridBaseDimensions;
    }

    return this.updateDashboardVariables(variables);
  }

  /***
   * Overwrites the state of shared dashboard with the state of the original dashboard.
   * @param originalDashboardId
   * @param sharedDashboardId
   * @returns {Promise}
   */
  updateDashboardStateFromOriginalDashboard(originalDashboardId, sharedDashboardId) {
    return new Promise((resolve, reject) => {
      smashClient.getDashboardState(originalDashboardId, response => {
        if (response.data.length === 0) {
          resolve();
        } else if (response.data.length === 1) {
          const originalDashboardState = response.data[0];
          this.findDashboardStateByDashboardId(sharedDashboardId)
            .then(state => {
              const newState = JSON.parse(originalDashboardState.dashboardState);

              state.dashboardState.forEach(s => {
                const oState = newState.find(os => os.widgetModel.id === s.widgetModel.id);
                if (oState) {
                  try {
                    // keep user's selection for control widget
                    if (s.widgetModel.type === "CONTROL_WIDGET" && s.widgetModel.metaData.type === "selection") {
                      oState.widgetModel.metaData.currentSelectionId = s.widgetModel.metaData.currentSelectionId;
                    }

                    // keep user's meta data except the control widget
                    if (s.widgetModel.type !== "CONTROL_WIDGET") {
                      oState.widgetModel.metaData = s.widgetModel.metaData;
                    }
                  } catch (e) {
                  }
                }
              });

              state.dashboardState = newState;
              this.dashboardStates[sharedDashboardId] = state;
              smashClient.saveDashboardState(JSON.parse(JSON.stringify(state)), JSON.parse(JSON.stringify(state)), (response) => {
                console.log('[Dashboard Service] Shared dashboard updated!');
                resolve(newState);
              });
            });
        }
      });
    });
  }
}

const instance = new DashboardService();
export default instance;


// WEBPACK FOOTER //
// ./src/core/services/dashboardService.js